import React from 'react';

import MembershipList from '../../components/admin/MembershipList';
import PageLayout from '../../components/layout/PageLayout';

const AdminRosterPage = () => {
  return (
    <PageLayout>
      <MembershipList />
    </PageLayout>
  );
};

export default AdminRosterPage;
